import { render, staticRenderFns } from "./PartnerRegisterIframe.vue?vue&type=template&id=60185c0e&"
import script from "./PartnerRegisterIframe.vue?vue&type=script&lang=ts&"
export * from "./PartnerRegisterIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports